<template>
  <van-radio-group v-model="itemValue" @change="onValueChange()">
    <van-radio
      v-for="(optionItem, index) in optionList"
      :key="index" 
      class="radio-item"
      :name="optionItem.id"
      :disabled="readonly"
    >
      <template #icon="props">
        <div 
          class="radio-icon" 
          :class="{'check': props.checked, 'disabled': readonly}"
          @click="onRadioItemClick(optionItem)"
        ></div>
      </template>
      <div class="title-wrap">
        <div class="left" @click="onRadioItemClick(optionItem)">{{ optionItem.name }}</div>
        <div class="right" v-if="readonly && submitOptionResByItem">
          <span class="r-text" :class="{'active': itemValue === optionItem.id}">{{ submitOptionResByItem[optionItem.id] }}票</span>
          <span class="r-text" :class="{'active': itemValue === optionItem.id}">{{ $filters.formatPercent(submitOptionResByItem[optionItem.id] / submitOptionResByItem.total) }}</span>
        </div>
      </div>
      <van-progress 
        v-if="readonly && submitOptionResByItem"
        class="progress"
        :percentage="submitOptionResByItem.total ? Math.floor((submitOptionResByItem[optionItem.id] / submitOptionResByItem.total) * 100) : 0"
        :show-pivot="false"
        :color="themeColor"
        stroke-width="1px"
      />
      <div 
        class="img-wrap" 
        v-if="optionItem.img && !readonly" 
        @click.stop="imgClick(optionItem)">
        <img 
          class="img" 
          :src="optionItem.img" 
        />
        <div class="icon-wrap">
          <img 
            class="icon" 
            src="https://stor.weixinhost.com/3/wxhost-images/rf_77a9fca7071c70e5c9f9811755303614" 
          />
        </div>
      </div>
      <SpecialValueInput 
        v-if="showOtherInput(optionItem)"
        v-model="specialValue"
        :disabled="readonly"
        @change="onValueChange()"
        @click.stop
      />
    </van-radio>
  </van-radio-group>
</template>

<script>
import _ from 'lodash';
import SpecialValueInput from '../comps/SpecialValueInput.vue';
import { RadioGroup, Radio, ImagePreview, Progress } from 'vant';

export default {
  props: {
    item: Object,
    submitValue: Object,
    readonly: Boolean
  },
  emits: ['change'],
  data() {
    return {
      itemValue: null,
      specialValue: null
    };
  },
  computed: {
    submitOptionResByItem() {
      return this.$store.state.submitOptionRes[this.item.id] || null;
    },
    optionList() {
      let opArr = [];
      const specialArr = [];
      this.item.option?.map(v => {
        if (v.special) {
          specialArr.push(v);
        } else {
          opArr.push(v);
        }
      });
      if (this.item.random) {
        opArr = _.shuffle(opArr);
      }
      return _.concat(opArr, specialArr);
    },
    themeColor() {
      return this.$store.state.formConfig.theme_color;
    },
  },
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Progress.name]: Progress,
    SpecialValueInput
  },
  methods: {
    // 【1】itemValue值设置
    setItemValue() {
      const index = this.optionList.findIndex(v => v.id === this.submitValue?.value);
      this.itemValue = index >= 0 ? this.submitValue?.value : null;
      this.specialValue = this.submitValue?.special_value || '';
    },
    // 【2】值监听
    onValueChange() {
      const index  = this.optionList.findIndex(v => v.id === this.itemValue && v.special === 'other');

      this.$emit('change', index >= 0 ? {
        value: this.itemValue,
        special_value: this.specialValue
      } : { value: this.itemValue });
    },
    showOtherInput(optionItem) {
      return optionItem.special === 'other' && optionItem.id === this.itemValue;
    },
    imgClick(optionItem) {
      ImagePreview([optionItem.img]);
    },
    onRadioItemClick(optionItem) {
      if (this.readonly) {
        return;
      }
      
      if (optionItem.id === this.itemValue) {
        setTimeout(() => {
          this.itemValue = null;
          this.onValueChange();
        }, 150);
      }
      
    }
  },
  created() {
    this.setItemValue();
  },
  async mounted() {
    
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.radio-item {
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;

  .img-wrap {
    .img-wrap();
    margin-top: 12px;
  }

  /deep/ .van-radio__label {
    flex: 1;
    min-width: 0;
    .form-item-text-1();
  }
  .radio-icon {
    .radio-icon();
  }
  .progress {
    margin-top: 6px;
  }
  .title-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      min-width: 0;
      overflow-wrap: anywhere;
    }
    .right {
      flex-shrink: 0;
      text-align: right;
    }
    .r-text {
      margin-left: 9px;
      color: @desc-color-2;
      &.active {
        color: var(--theme-main-color);
      }
    }
  }
}
</style>
